export const EVENT_LEAGUE_LISTING = "EVENT_LEAGUE_LISTING";
export const EVENT_LEAGUE_SHOW = "EVENT_LEAGUE_SHOW";
export const EVENT_LEAGUE_CREATE = "EVENT_LEAGUE_CREATE";
export const EVENT_LEAGUE_UPDATE = "EVENT_LEAGUE_UPDATE";
export const EVENT_CATEGORY_DROPDOWN = "EVENT_CATEGORY_DROPDOWN";
export const EVENT_TEAMS_DROPDOWN = "EVENT_TEAMS_DROPDOWN";